import { Component, OnInit } from '@angular/core';
import { GoogleMapsAPIWrapper } from '@agm/core';
import { GoogleMapsService } from '../services/google-maps.service';

@Component({
    selector: 'app-maps-content',
    template: ''
})
export class MapsContentComponent implements OnInit {

    constructor(
        private mapApiWrapper: GoogleMapsAPIWrapper,
        private googleMapsService: GoogleMapsService) {

    }

    ngOnInit() {

        this.googleMapsService.setWrapper(this.mapApiWrapper);

    }

}



// WEBPACK FOOTER //
// ./src/app/maps-content/maps-content.component.ts